import { render, staticRenderFns } from "./ScrollTopButton.vue?vue&type=template&id=474741c0&"
import script from "./ScrollTopButton.vue?vue&type=script&lang=js&"
export * from "./ScrollTopButton.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTopButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports